/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthorisationSummary } from './AuthorisationSummary';
import type { ClientSummary } from './ClientSummary';
import type { DeviceDetails } from './DeviceDetails';
import type { DQPSummaryItem } from './DQPSummaryItem';
import type { InspectionOutcome } from './InspectionOutcome';
import type { MDComponent } from './MDComponent';
import type { Photo } from './Photo';
import type { Reading } from './Reading';
import type { ReasonForInspection } from './ReasonForInspection';
import type { Seal } from './Seal';
import type { uuid } from './uuid';

import { ChangedDeviceDetails } from './ChangedDeviceDetails';

/**
 * A full detail of a Certificate
 */
export type CertificateItem = {
	id: uuid;
	/**
	 * The Certificate Identifier applied after submission
	 */
	issuedCertificateIdentifier?: string;
	/**
	 * The date of issue for the Certificate
	 */
	issuedDate?: string;
	/**
	 * Is Intervention Required by the Water Officer?
	 */
	isinterventionrequired?: boolean;
	/**
	 * The status of the Certificate
	 */
	status: CertificateItem.status;
	dqp?: DQPSummaryItem;
	client: ClientSummary;
	authorisation: AuthorisationSummary;
	/**
	 * The Meter Case Code value
	 */
	meterCaseCode: string;
	reasonForInspection: ReasonForInspection;
	/**
	 * The Authorisation Reference if it was provided
	 */
	providedAuthorisationReference?: string;
	newDeviceDetails?: DeviceDetails;
	existingDeviceDetails?: DeviceDetails;
	changedExistingDeviceDetails?: ChangedDeviceDetails;
	existingDeviceReading?: Reading;
	compliantMD?: boolean;
	/**
	 * The non-compliance statement
	 */
	nonComplianceStatement?: string;
	/**
	 * The modifications required in  order to reach compliance
	 */
	modificationsRequired?: string;
	/**
	 * The date of inspection
	 */
	inspectedDate?: string;
	inspectionOutcome?: InspectionOutcome;
	/**
	 * MD Diagnostics Record Shared?
	 */
	diagnosticsRecordShared?: boolean;
	/**
	 * MD Configuration Settings Shared?
	 */
	configurationSettingsShared?: boolean;
	/**
	 * Open Channel Calibration Report Shared?
	 */
	openChannelCalibrationReportShared?: boolean;
	/**
	 * The components of a Modular Device
	 */
	mdComponents: Array<MDComponent>;
	/**
	 * The tamperproof seals installed
	 */
	seals: Array<Seal>;
	/**
	 * The photos of the Certificate
	 */
	photos: Array<Photo>;
};
export namespace CertificateItem {
	/**
	 * The status of the Certificate
	 */
	export enum status {
		AWAITING_INFORMATION = 'Awaiting Information',
		IN_PROGRESS = 'In Progress',
		SUBMITTED = 'Submitted',
		CANCELLED = 'Cancelled',
	}
}
